import * as React from "react";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
};

const variants = {
  primary:
    "bg-[#40315f] text-white shadow-sm hover:bg-[#34264f] focus-visible:ring-[#40315f]",
  secondary:
    "border border-[#d7d3df] bg-white text-[#30263f] hover:border-[#b8b1c4] hover:bg-[#faf9fc] focus-visible:ring-[#76668f]",
  ghost:
    "text-[#625a6c] hover:bg-[#eeeaf2] focus-visible:ring-[#76668f]",
};

export function Button({
  className = "",
  variant = "primary",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex h-10 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${variants[variant]} ${className}`}
      {...props}
    />
  );
}
